export default "/images/454fe1936b40cb4960f77fdfb0f6b0b4.avif";